import React from "react";
// import { Flex, Text, Checkbox, Message, PopoverTrigger, PopoverContent, Popover } from "@digitallabs/one-x-ui";
import { Flex, Text, Checkbox, Message, PopoverTrigger, PopoverContent, Popover } from "../../../resourses/digitallabs/one-x-ui";
import { MAIN_STEPS } from "../../../constants/constants";
import { InfoIcon } from "@phosphor-icons/react";
import { getDMQMedicalConditions, saveCurrentInternalStep, saveCurrentStep } from "../../../utils/formStorage";

const DynamicCheckboxMultiselect = ({ field, fieldRefs, value, isMain, step, submitted, errors, updateValue, renderLabelWithPrefix, formData }) => {
  const fieldName = field.name;
  const selectedValues = Array.isArray(value) ? value : [];
  const medicalConditions = getDMQMedicalConditions();
  console.log("medical conditions", medicalConditions);

  const handleRedirect = (redirectionStep, redirectionInternalStep) => {
    saveCurrentStep(redirectionStep);
    saveCurrentInternalStep(redirectionInternalStep);

    window.location.reload();
  };

  const handleMultiSelectChange = (option) => {
    let updated = [...selectedValues];

    const isSelected = updated.includes(option);

    if (option === "None of the above") {
      updated = isSelected ? [] : ["None of the above"];
    } else {
      if (isSelected) {
        updated = updated.filter((v) => v !== option);
      } else {
        updated.push(option);
      }

      updated = updated.filter((v) => v !== "None of the above");
    }

    updateValue(fieldName, updated);
  };

  const getDisabilityConfig = (option) => {
    return field.check_disability?.find((item) => item.valid_answer_to_disable === option);
  };

  return (
    <Flex key={fieldName} direction="column" gap="xs" className="dfh-field-wrapper" ref={(el) => (fieldRefs.current[fieldName] = el)}>
      {/* Label */}
      <Text className={isMain ? (step === MAIN_STEPS.PERSONAL_DETAILS ? "dfh-label-small" : "dfh-label") : "subquestion-label"}>
        {renderLabelWithPrefix(isMain, field.question, step)}
      </Text>

      {/* Error */}
      {submitted && errors[fieldName] && (
        <Flex align="center" gap="xs">
          <Message
            message={{
              primary: errors[fieldName],
            }}
            style={{ width: "100%", marginBottom: "10px" }}
            onClose={() => {}}
            variant="error"
          />
        </Flex>
      )}

      {/* Options */}
      <Flex direction="column" gap="8px" style={{ marginLeft: "14px" }}>
        {field.valid_answers?.map((option) => {
          const checked = selectedValues.includes(option);

          const disabilityConfig = getDisabilityConfig(option);
          console.log("disabilityConfig", disabilityConfig);

          const shouldDisable = disabilityConfig && medicalConditions?.[disabilityConfig.value_to_check] === false;
          return (
            <Flex key={option} align="center" justify="space-between" gap="sm">
              <Flex align="center" gap="sm">
                <Checkbox checked={checked} disabled={shouldDisable} onChange={() => handleMultiSelectChange(option)} />

                <Text style={{ fontSize: "14px" }}>{option}</Text>
              </Flex>

              {shouldDisable && disabilityConfig && (
                <Popover
                  mode="light"
                  portalled
                  positioning={{
                    placement: "bottom",
                  }}
                  size="sm"
                  withCloseButton
                >
                  <PopoverTrigger asChild>
                    <InfoIcon size={18} weight="fill" style={{ cursor: "pointer" }} />
                  </PopoverTrigger>

                  <PopoverContent mode="light" size="sm" withCloseButton>
                    <p>
                      Based on your response in the Main Medical Questionnaire, you indicated that you do not have{" "}
                      {disabilityConfig.label_inLine ? disabilityConfig.label_inLine : option}. If you'd like to update your response, please{" "}
                      <a
                        href="#"
                        onClick={(e) => {
                          e.preventDefault();

                          handleRedirect(disabilityConfig.redirection_step, disabilityConfig.redirection_internal_step);
                        }}
                      >
                        click here
                      </a>
                      .
                    </p>
                  </PopoverContent>
                </Popover>
              )}
            </Flex>
          );
        })}
      </Flex>

      {/* Info text */}
      {field.info_text && <div className="dfh-info-text">{field.info_text}</div>}
    </Flex>
  );
};

export default DynamicCheckboxMultiselect;
